// Copyright (c) Docugami, Inc. All rights reserved.

import { Link } from '@fluentui/react';
import { DgFlexCenteredColumn } from 'components/common/DgCommonStyledComponents';
import { dgFontFamily } from 'components/common/Fonts';
import { appContentColor } from 'components/shell/presentation/AppStyles';
import styled from 'styled-components';
import { IconDescriptor, IconRenderer } from './IconRenderer';

const CoachMarkColumn = styled(DgFlexCenteredColumn)`
    flex: 1;
    align-items: center;
    justify-content: center;
    gap: 20px;
    overflow: hidden;
`;

const EmptyLabel = styled.span`
    font-family: ${dgFontFamily};
    font-weight: 300;
    font-size: 24px;
    line-height: 48px;

    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    color: ${appContentColor};
`;

interface LinkItem {
    text: string;
    onClick: () => void;
}

const GraphicContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 15px;
`;

interface LandingPageCoachMarkProps {
    iconSources: IconDescriptor[];
    descriptionText: string;
    link: LinkItem;
}

export const LandingPageCoachMark = (props: LandingPageCoachMarkProps): JSX.Element => {
    const graphic = (
        <GraphicContainer>
            {props.iconSources.map((source, index) => {
                return <IconRenderer key={`graphic_${source.name}_${index}`} source={source} width={150} height={150} containerHeight={150} />
            })}
        </GraphicContainer>
    );

    return (
        <CoachMarkColumn>
            {graphic}
            <EmptyLabel>
                <span>{props.descriptionText}</span>
                <div>
                    <span>Get started by </span>
                    <Link styles={{ root: { fontFamily: dgFontFamily, fontWeight: 500 } }} onClick={props.link.onClick}>{props.link.text}</Link>
                </div>
            </EmptyLabel>
        </CoachMarkColumn>
    )
}